<template>
	<v-dialog v-model="value" persistent width="300">
		<v-card color="gradiente" dark>
			<v-card-text>
				{{ text }}
				<v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: ["value", "text"]
	};
</script>

<style>
</style>
